export default "__VITE_ASSET__gJZX3n0X__"